import React, { Component } from 'react';
import { connect } from 'react-redux'
import { CircularProgress } from '@mui/material';
import HeaderLogo from '../../images/headerLogo'
import { push } from 'connected-react-router'
import { InactivityMonitorConstants } from '../inactivity_monitor/InactivityMonitorConstants'
import auth from '../../services/auth/AuthProvider';
import AuthActions from '../../store/authRedux'
import HrbTranslate from '../language/HrbTranslate';

class Logout extends Component {
    constructor(props) {
        super(props);

        this.logoutType = 'normal'

        this.state = {
            lang: this.props.lang,  
            isloading: false
        }
       
    }

    componentWillMount() {

        if (auth.isAuthenticated()) {
            // VAI-1174: this page is meant to be only a cleanup page post-logout. If a user ever
            //           navigates directly here, we should make sure the token has actually been invalidated.
            this.setState({ isloading: true })
            this.props.logoutUser()

        } else {
            if (window.sessionStorage.getItem('spark.logouttype') === 'auto') {
                this.logoutType = 'auto';
            } else if (window.sessionStorage.getItem('spark.logouttype') === 'error') {
                this.logoutType = 'error';
            }
            window.sessionStorage.removeItem('spark.logouttype')

            // VAI-952: set signed out and reset the Client info here, as otherwise, 
            //          it clears before we hit the logout page (and it looks really bad)
            this.props.finalizeLogout()
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.lang !== newProps.lang) {
            this.setState({ lang: newProps.lang })
        }
    }

    onSignInClick = (e) => {
        this.props.pushNavigation('/')

    }

    render() {       

        var content = []
        var loader = <div className="hrb-progress-container" style={{ paddingTop: 30 }}>
                         <CircularProgress className="hrb-progress" />
                     </div>
        
        if (this.logoutType === 'auto') {
            var totalTime = Math.floor(InactivityMonitorConstants.TIME_TO_WARNING_MINS + InactivityMonitorConstants.TIME_TO_SIGNOUT_MINS);

            content.push(<div className="logout_subtitle" key='logoutsubtitle'><HrbTranslate text='Logout.SubTitle' /></div>)
            content.push(<div className="logout_center_content" key='logoutcontent'><HrbTranslate text='Logout.MessageAuto' params={{ timeoutLength: totalTime }} /></div>)
        } else if (this.logoutType === 'error') {
            content.push(<div className="logout_subtitle" key='logoutsubtitle'><HrbTranslate text='Logout.SubTitle' /></div>)
            content.push(<div className="logout_center_content" key='logoutcontent'><HrbTranslate text='Logout.MessageError' /></div>)
        } else {
            content.push(<div className="logout_center_content" key='logoutcontent'><HrbTranslate text='Logout.Message1' /></div>)
        }

        var buttonLabel = this.logoutType === 'auto' ? 'Logout.SignBackInButtonLabel' : 'Logout.SignInButtonLabel'

        return (
            <div>
                <div style={{ top: '-70px', position: 'relative' }} ><hr style={{ display: 'block', height: '1px', border: '0', borderTop: '1px solid #E4E4E4' }} /></div>
                {this.state.isloading === true ? loader :
                    <div className="logoutOuter">
                        <div className="logoutBox" >
                            <div className="logoutLogoHolder">
                                <HeaderLogo lang={'en'} darkText={true} width={"250px"} />
                            </div>
                            {content}
                            <button onClick={this.onSignInClick} className="button is-link is-fullwidth">
                                <span><HrbTranslate text={buttonLabel} /></span>
                            </button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lang: state.layout.lang
    }
}

const mapDispatchToProps = (dispatch) => ({
    pushNavigation: (path) => dispatch(push(path)),
    finalizeLogout: () => dispatch(AuthActions.finalizeLogout()),
    logoutUser: () => dispatch(AuthActions.logoutUser()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Logout)